<a>
    <button mat-raised-button class="btn btn-squirrel pull-left" style="margin-top: 0px;margin-left: 0px" matTooltip="Squirrel Umgebung ändern"
            (click)="editSquirrelEnvironmentDialog()">Ändern</button>
</a>
<a>
    <button mat-raised-button class="btn btn-squirrel pull-left" style="margin-top: 0px;margin-left: 0px" matTooltip="Squirrel Umgebung löschen"
            (click)="deleteSquirrelEnvironmentDialog()">Löschen</button>
</a>

<!-- <a matTooltip="Update Squirrel Environment" (click)="editSquirrelEnvironmentDialog()">
    <mat-icon aria-hidden="false" aria-label="icon">{{icon_edit}}</mat-icon>
</a>
<a matTooltip="Delete Squirrel Environment" (click)="deleteSquirrelEnvironmentDialog()">
    <mat-icon aria-hidden="false" aria-label="icon">{{icon_delete}}</mat-icon>
</a> -->
